import login from "./loginSlice";
import house from "./houseSlice";

import { combineReducers } from 'redux';

export default combineReducers({
    login,
    house,
});
